<mb-alert *ngIf="showMessage" type="notification">
  <mb-alert-description>
    Para consultar el RNT de los alojamientos nacionales, ingrese al link
    <a href="http://www.rues.org.co/RNT" target="_blank" class="link"
      >www.rues.org.co/RNT</a
    >.
    <span (click)="openModal()" class="link">ver más</span>
  </mb-alert-description>
</mb-alert>
